export const DISABLE_BUILDER_QUERY_CHECK = 'DISABLE_BUILDER_QUERY_CHECK';

export default {
  rollOut: 0,
  name: DISABLE_BUILDER_QUERY_CHECK,
};
